import { Box, Typography } from "@mui/material";
import { Filters } from "./containers/Filters";
import { CardsContainer } from "./containers/CardsContainer";
import { useEffect, useState } from "react";
import { PropostasTempoGrafico } from "./containers/PropostasTempoGrafico";
import { ValorTempoGrafico } from "./containers/ValorTempoGrafico";
import { CardsData } from "./containers/types";
import { DashboardProvider, GraficosResponse } from "src/providers/dashboard";
import { FiltersStoreType, dashboardFilterStore$ } from "src/store/dashboard/filters.store";
import { useObservable } from "src/framework/store/storeUtil";
import { isValid } from "date-fns";
import { clearDashboardFilter } from "src/store/dashboard/filters.store";
import { UserType } from "src/framework/store/LoginStore/login.types";
import { ExtraInfoUsuario } from "src/providers/cadastros/ContaProvider/types";
import "./styles.css"
import { LoginStore } from "src/framework/store/LoginStore";
import { DateUtil } from "src/framework/commons/DateUtils";

const getGroupType = (startDate: string, endDate: string) => {
  if (!endDate || !startDate) return 'month'
  return DateUtil.diffDays(new Date(startDate), new Date(endDate)) > 31 ? 'month' : 'day'
}
const groupByMonth = (payload: GraficosResponse[]) => {
  const result: GraficosResponse[] = []

  payload.forEach(item => {
    const data = item.data.split('-')
    const ano = data[0]
    const mes = data[1]
    const index = result.findIndex(item => item.data === `${mes}/${ano}`)
    if (index === -1) {
      result.push({
        data: `${mes}/${ano}`,
        total_propostas: item.total_propostas,
        total_valor_comissionamento: item.total_valor_comissionamento,
        total_valor_projetos: item.total_valor_projetos,
        total_valor_servico: item.total_valor_servico
      })
    } else {
      result[index] = {
        data: `${mes}/${ano}`,
        total_propostas: result[index].total_propostas + item.total_propostas,
        total_valor_comissionamento: result[index].total_valor_comissionamento + item.total_valor_comissionamento,
        total_valor_projetos: result[index].total_valor_projetos + item.total_valor_projetos,
        total_valor_servico: result[index].total_valor_servico + item.total_valor_servico
      }
    }
  })
  return result 
}

const dashboardProvider = new DashboardProvider()
export function Dashboard(){
  const dashboardFilterStore = useObservable<FiltersStoreType>(dashboardFilterStore$)
  const currentUser = useObservable<UserType & ExtraInfoUsuario | null>(LoginStore.userInfoSubject())

  const [isLoading, setIsLoading] = useState(false)
  const [graficoNumPropostas, setGraficoNumPropostas] = useState<any[]>([])
  const [graficoValores, setGraficoValores] = useState<any[]>([])
  const [cardData, setCardData] = useState<CardsData>({
    comissionamento: 0,
    potenciaMediaGeradores: 0,
    potenciaTotalGeradores: 0,
    ticketMedio: 0,
    totalPropostas: 0,
    valorTotalGeradores: 0,
    valorServico: 0,
  })

  useEffect(()=>{
    return () => clearDashboardFilter()
  },[])

  useEffect(() => {
    if (!dashboardFilterStore) return;

    const isValidStartDate = dashboardFilterStore?.startDate ? isValid(new Date(dashboardFilterStore.startDate)) : true
    const isValidEndDate =  dashboardFilterStore?.endDate ? isValid(new Date(dashboardFilterStore.endDate)) : true
    if (!isValidStartDate || !isValidEndDate) return

    setIsLoading(true)
    Promise.all([
      dashboardProvider.buscarIndicadores(dashboardFilterStore || null),
      dashboardProvider.buscarGraficos(dashboardFilterStore || null),
    ]).then(([indicadores, graficos]) => {
      if (indicadores) {
        setCardData({
          comissionamento: indicadores.valor_comissionamento,
          potenciaMediaGeradores: indicadores.potencia_media_geradores_kw,
          potenciaTotalGeradores: indicadores.potencia_total_geradores_kw,
          ticketMedio: indicadores.ticket_medio_gerador,
          totalPropostas: indicadores.total_propostas,
          valorTotalGeradores: indicadores.valor_total_geradores,
          valorServico: indicadores.valor_servico
        })
      }

      if (!graficos?.length) {
        setGraficoNumPropostas([])
        setGraficoValores([])
        return
      }

      if (graficos) {
        const startDate = graficos[0].data
        const endDate = graficos[graficos?.length - 1].data

        const groupType = getGroupType(startDate, endDate)
        const payload = groupType === 'day' ? graficos : groupByMonth(graficos)

        setGraficoNumPropostas(payload.map(item => {
          let data = item.data
          const splittedData = item.data.replace('/', '-').split('-')

          if (splittedData.length === 3) {
            data = `${splittedData[2]}/${splittedData[1]}/${splittedData[0]}`
          }

          return {
            Data: data,
            Propostas: item.total_propostas,
          }
        }))

        setGraficoValores(payload.map(item =>{
          let data = item.data
          const splittedData = item.data.replace('/', '-').split('-')

          if (splittedData.length === 3) {
            data = `${splittedData[2]}/${splittedData[1]}/${splittedData[0]}`
          }

          return {
            Data: data,
            "Valor dos Serviços": item.total_valor_servico,
            "Valor dos Projetos": item.total_valor_projetos,
            "Valor do Distribuidor": item.total_valor_comissionamento,
          }
        }))
      }
    }).finally(() => {
      setIsLoading(false)
    })

  },[dashboardFilterStore])

  if (!currentUser) return null
  return (
    <div>
      <Typography align="left" variant="h5" className="dashboard-title">Bem vindo(a), {currentUser.name}</Typography>

      <Filters />
      
      <CardsContainer isLoading={isLoading} valores={cardData} />

      <Box width={"auto"} height={"400px"}>
        <Box marginY={3}>
          <Typography align="left" variant="h6">Quantidade de proposta x tempo</Typography>
        </Box>
        <PropostasTempoGrafico isLoading={isLoading} data={graficoNumPropostas} />
      </Box>

      <Box width={"auto"} height={"400px"}>
        <Box marginTop={10} marginBottom={3}>
          <Typography align="left" variant="h6">Valor (R$) x tempo</Typography>
        </Box>
        <ValorTempoGrafico isLoading={isLoading} data={graficoValores} />
      </Box>
    </div>
  )
}